import {Routes} from '@angular/router'
import {HOME_ROUTE} from './application/constants'
import {VideoPlayerComponent} from './video-player/video-player.component'

export const routes: Routes = [
  {
    path: HOME_ROUTE,
    component: VideoPlayerComponent,
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: HOME_ROUTE
  }
]
